import { parseURLParams } from '../utils/helpers';

const LoginRoute = ({ children }) => {
	const params = parseURLParams(window.location.href);
	const code = params?.code?.[0];

	return !code ? children : null;
};

export default LoginRoute;
